// extracted by mini-css-extract-plugin
module.exports = {"csr_h5_G":"G_csr_h5_G__wvcAw"};